import { Component, input } from '@angular/core';
import { AdminCaseTableItem } from '../cases.component';

@Component({
  selector: 'app-attorney-names-column',
  templateUrl: './attorney-names-column.component.html',
  styleUrls: ['./attorney-names-column.component.scss'],
})
export class AttorneyNamesColumnComponent {
  readonly element = input.required<AdminCaseTableItem>();
}
